import { Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as QuickStartHeroImage } from '../../../../assets/images/quick-start-hero.svg'

const imageSize = 160

export const QuickStartHero = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="column" gap={Spacing.S24}>
      <QuickStartHeroImage height={imageSize} width={imageSize} />
      <Flex flexDirection="column" gap={Spacing.S8}>
        <Text variant="h1" weight="semiBold">
          {t('quick_start.hero.title')}
        </Text>
        <Text variant="bodyMD">{t('quick_start.hero.subtitle')}</Text>
      </Flex>
    </Flex>
  )
}
